/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const guidebookOverviewPageStyle = {
  overviewHeading: {
    textAlign: "center",
  },
  box: {
    padding: "10px 20px",
  },
  boxHeading: {
    color: "primary.main",
    fontWeight: 500,
  },
};

export default guidebookOverviewPageStyle;
